import initialState from './../../initialState';

const sortByDate = (a, b) =>
  -(a.checkin < b.checkin) || +(a.checkin !== b.checkin);

export default (state = initialState.inicio, { type, value, response }) => {
  switch (type) {
    case 'LIST_PRESENCAS_REQUEST':
      return {
        ...state,
        presencas: {
          ...state.presencas,
          fetching: 1
        }
      };
    case 'LIST_PRESENCAS_SUCCESS':
      //let contratados = response.map(v => v.contratado);

      return {
        ...state,
        /*contratados: {
                    ...state.contratados,
                    result: [
                        ...state.contratados.result.filter(v => !contratados.some(r => r.id === v.id)),
                        ...contratados
                    ].sort(sortByText),
                    errors: []
                },*/
        presencas: {
          result: response.sort(sortByDate),
          fetching: 2,
          errors: []
        }
      };
    case 'LIST_PRESENCAS_FAILURE':
      return {
        ...state,
        presencas: {
          ...state.presencas,
          fetching: 0,
          errors: ['Falha na obtenção da lista']
        }
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/inicio/reducer.js